var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "messages",
      class: [_vm.showMessages ? "messages-active" : "messages-inactive"],
    },
    [
      _c(
        "div",
        { staticClass: "message success", class: { show: _vm.showSuccess } },
        [
          _c("i", {
            staticClass: "fa fa-times",
            on: {
              click: function ($event) {
                return _vm.closeMessage("success")
              },
            },
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-check-circle indicator" }),
          _vm._v(" "),
          _c("div", { staticClass: "message-inner" }, [
            _vm.messages.success.length == 1
              ? _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.messages.success[0].message),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.messages.success.length > 1
              ? _c(
                  "ul",
                  _vm._l(_vm.messages.success, function (message) {
                    return _c("li", {
                      domProps: { innerHTML: _vm._s(message.message) },
                    })
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "message error", class: { show: _vm.showError } },
        [
          _c("i", {
            staticClass: "fa fa-times",
            on: {
              click: function ($event) {
                return _vm.closeMessage("error")
              },
            },
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-exclamation-circle indicator" }),
          _vm._v(" "),
          _c("div", { staticClass: "message-inner" }, [
            _vm.messages.error.length == 1
              ? _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.messages.error[0].message),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.messages.error.length > 1
              ? _c(
                  "ul",
                  _vm._l(_vm.messages.error, function (message) {
                    return _c("li", {
                      domProps: { innerHTML: _vm._s(message.message) },
                    })
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "message info", class: { show: _vm.showInfo } },
        [
          _c("i", {
            staticClass: "fa fa-times",
            on: {
              click: function ($event) {
                return _vm.closeMessage("info")
              },
            },
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-info-circle indicator" }),
          _vm._v(" "),
          _c("div", { staticClass: "message-inner" }, [
            _vm.messages.info.length == 1
              ? _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.messages.info[0].message) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.messages.info.length > 1
              ? _c(
                  "ul",
                  _vm._l(_vm.messages.info, function (message) {
                    return _c("li", {
                      domProps: { innerHTML: _vm._s(message.message) },
                    })
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "message warning", class: { show: _vm.showWarning } },
        [
          _c("i", {
            staticClass: "fa fa-times",
            on: {
              click: function ($event) {
                return _vm.closeMessage("warning")
              },
            },
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-info-circle indicator" }),
          _vm._v(" "),
          _c("div", { staticClass: "message-inner" }, [
            _vm.messages.warning.length == 1
              ? _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.messages.warning[0].message),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.messages.warning.length > 1
              ? _c(
                  "ul",
                  _vm._l(_vm.messages.warning, function (message) {
                    return _c("li", {
                      domProps: { innerHTML: _vm._s(message.message) },
                    })
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }